import {
  TextIconColor,
  Typography,
  TypographyFont,
  TypographySize,
  TypographyWeight
} from '../core';

interface SettingsSectionProps {
  children: React.ReactNode | React.ReactNode[];
  title: string;
  description?: string;
  headerEndElement?: React.ReactNode;
}

const SettingsSection = ({
  title,
  children,
  description,
  headerEndElement
}: SettingsSectionProps) => (
  <div
    className="flex w-full flex-col gap-2"
    data-testid="settings-section-container"
  >
    <div className="flex w-full flex-col" data-testid="settings-section-header">
      <div
        className="flex w-full items-center justify-between"
        data-testid="settings-section-header-top"
      >
        <Typography
          color={TextIconColor.PRIMARY}
          font={TypographyFont.HEADING}
          size={TypographySize.H4}
          weight={TypographyWeight.SEMI_BOLD}
        >
          {title}
        </Typography>
        {!description && headerEndElement}
      </div>
      {description && (
        <div
          className="mt-6 flex w-full items-center justify-between"
          data-testid="settings-section-header-bottom"
        >
          <Typography
            color={TextIconColor.SECONDARY}
            italic
            size={TypographySize.MEDIUM}
          >
            {description}
          </Typography>
          {headerEndElement}
        </div>
      )}
    </div>
    {children}
  </div>
);

export default SettingsSection;
